import moment from "moment";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useMount, useUpdateEffect } from "react-use";
import { useState } from "react";
import { getViewCertificateData } from "../../api";
import { useQueryClient } from "react-query";
import { API_URL } from "../../api/common";
import { useLocationQuery } from "../../util/common";
import CertificateView from "../../components/certificate/CertificateView";

const CertificateViewPage = () => {
  const { student_id, id } = useLocationQuery();
  const queryClient = useQueryClient();
  const [canvas, setCanvas] = useState(null);
  const [img, setImg] = useState(null);
  const [imgLoad, setLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [studentInfo, setStudent] = useState([]);
  const [courseInfo, setInfo] = useState([]);
  const [content, setContents] = useState([]);
  const [date, setDate] = useState("");
  const [logo, setLogo] = useState(null);
  const [signature, setSignature] = useState(null);

  const handleDown = () => {
    const image = canvas.toDataURL("image/jpg");
    const img_w = 210;
    // const page_h = img_w * 1.414;
    const img_h = (canvas.height * img_w) / canvas.width;
    const doc = new jsPDF();
    doc.addImage(image, "jpg", 0, 0, img_w, img_h);
    const fileNames = studentInfo.reduce(
      (arr, [_, cur]) => {
        arr.push(cur.replace(/\s|\./g, ""));
        return arr;
      },
      ["certificate"]
    );
    doc.save(`${fileNames.join("_")}.pdf`);
  };

  useUpdateEffect(() => {
    let result = true;
    // result = studentInfo.reduce((acc, cur) => {
    //   if (cur && cur.length === 2) {
    //     return cur[1] ? acc : false;
    //   }
    //   return false;
    // }, result);
    result = courseInfo.reduce((acc, cur) => {
      if (cur && cur.length === 2) {
        return cur[1] ? acc : false;
      }
      return false;
    }, result);
    result = content.reduce((acc, cur) => {
      return cur ? acc : false;
    }, result);
    result = result && !!date;
    if (logo) {
      result = result && imgLoad;
    }
    if (result) {
      html2canvas(document.getElementById("cert_cvs")).then((cvs) => {
        setCanvas(cvs);
        const image = cvs.toDataURL("image/jpg");
        setLoading(false);
        setImg(image);
      });
    }
  }, [studentInfo, courseInfo, content, imgLoad]);
  useMount(async () => {
    if (student_id && id) {
      const result = await queryClient.fetchQuery(
        [`certificate/${student_id}`],
        {
          queryFn: () => getViewCertificateData({ id, student_id }),
        }
      );
      if (result.result) {
        const { data } = result;
        const {
          student,
          lecture,
          issued_date,
          signature,
          contents,
          logo: lid,
        } = data;
        const logo = `${API_URL()}certificate/${lid}`;
        setLogo(logo);
        if (student) {
          const { birth_date, name, school } = student;
          setStudent([
            ["성명", name],
            ["학교명", school],
            ["생년월일", new moment(birth_date).format("YYYY. MM. DD")],
          ]);
        }
        if (lecture) {
          const {
            name,
            time,
            date: { start, end },
          } = lecture;
          setInfo([
            ["과정명", name],
            [
              "수료기간",
              `${new moment(start).format("YYYY. MM. DD")} ~ ${new moment(
                end
              ).format("YYYY. MM. DD")} (${time})`,
            ],
          ]);
        }
        setDate(new moment(issued_date).format("YYYY년 MM월 DD일"));
        setSignature(signature);
        setContents(contents);
      }
    }
  });
  return (
    <div className="flex flex-col items-center justify-center w-full gap-2 mx-auto md:w-8/12 lg-6/12 md:px-2">
      <button
        className={`btn ${
          loading ? "btn-disabled" : "btn-primary"
        } btn-sm w-full m-2 md:ml-0 md:w-auto md:self-end`}
        onClick={handleDown}
      >
        다운로드
      </button>
      <div className="w-full min-h-screen flex">
        {loading && (
          <progress className="progress progress-primary w-3/4 m-auto"></progress>
        )}
        {img && (
          <img
            src={img}
            alt={`${student_id}_수료증`}
            className="w-full h-auto self-baseline mb-8"
          />
        )}
      </div>
      {!img && (
        <CertificateView
          {...{
            id: "cert_cvs",
            studentInfo,
            courseInfo,
            content,
            date,
            logo,
            signature,
            imgLoad,
            setLoaded,
          }}
        />
      )}
    </div>
  );
};

export default CertificateViewPage;
